import { combineReducers } from 'redux'
import drawer from './abscencesDrawer'
import tab from './tabs/abscences'

export default combineReducers({
  tab,
  drawer,
})
